import { useMemo } from 'react';
import { TableColumnType } from 'antd';

import { ActionsColumn } from 'components/common';

export const useTableActionsColumn = <T,>(
  loading: boolean,
  isEditing: (row: T) => boolean,
  save: (row: T) => void,
  edit: (row: T) => void,
  cancel: () => void,
) => {
  return useMemo<TableColumnType<T>>(() => {
    return {
      key: 'actions',
      align: 'right',
      width: '120px',
      render: (_: unknown, row: T) => (
        <ActionsColumn
          editing={isEditing(row)}
          loading={loading}
          save={() => save(row)}
          edit={() => edit(row)}
          cancel={cancel}
        />
      ),
    };
  }, [isEditing, save, edit, cancel, loading]);
};
